import React from "react";
import "./App.css"; // Import the CSS file for styling

function ArbitrationMediation(){

        return <div>

<img src="/supreme-court-of-india.jpg" alt="Header" />
<h5>Arbitration Mediation Page under Construction</h5>

        </div>


}




export default ArbitrationMediation;